export default "__VITE_ASSET__DeFmg8ld__"